export default __webpack_public_path__ + "static/media/icon-delete.73543f31.svg";